import { axiosInstance } from './axios'

export const get = async ({ path, config }) => {
  return await axiosInstance.get(path, config)
}

export const post = async ({ path, payload }) => {
  return await axiosInstance.post(path, payload)
}
